export default () =>
  `${window.location.origin}${process.env.TAKER_PUBLIC_PATH}`;
